var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"dataset-sources"},[_c('ul',{staticClass:"dataset-sources-list"},_vm._l((_vm.sources),function(source,index){return _c(_setup.DatasetSource,{key:index,attrs:{"source":source}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }